import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { TextareaInput } from "../components/Textarea";
import Statistics from "../components/Statistics";
import { HiDownload } from 'react-icons/hi';
import exportFromJSON from 'export-from-json'
import { useAuth } from "../context/AuthProvider";
import Alert from "../components/Alert";
import WordTag from "../components/WordTag";
import InfoPoint from "../components/InfoPoint";
import config from '../config';


function Analyse() {
  const { login, user } = useAuth();
  const [jsonData, setJsonData] = useState(null);
  const [analysisId, setAnalysisId] = useState(0);
  const [countWord, setCountWord] = useState(0);
  const [countOrangeWord, setCountOrangeWord] = useState(0);
  const [countRedWord, setCountRedWord] = useState(0);
  const [isAlertVisible, setAlertVisible] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [editingWord, setEditingWord] = useState(['', '', '', '']);
  const [updatedJsonData, setUpdatedJsonData] = useState(null);
  const [correctedJsonData, setCorrectedJsonData] = useState(null);
  const [modalStatText, setModalStatText] = useState(false);
  const [modalStatError, setModalStatError] = useState(false);
  const [modalStatComp, setModalStatComp] = useState(false);

  const location = useLocation();
  useEffect(() => {
    if (location.state) {
      setCountWord(0);
      setCountOrangeWord(0);
      setCountRedWord(0);
      document.getElementById('result').innerHTML = '';
      document.getElementById('resultError').innerHTML = '';
      setJsonData(null);
      setUpdatedJsonData(null);
      setCorrectedJsonData(null);
      setAnalysisId(location.state.id);

      if (location.state.usage){
        // Recharge l'analyse d'usage qui a déjà été effectuée
        const result = location.state.usage

        const data = JSON.parse(result)
        let outputText = [];

        Object.entries(data).forEach((mot) => {
          mot[1]['INDEX'] = mot[0];
          if (typeof mot[1].WORD === 'string' && mot[1].INDEX !== 'top') {
            let wordElement = document.createElement('span');
            wordElement.innerText = mot[1].WORD;
            if (mot[1].SYNT !== 'PON') {
              if (mot[1].FORM === 'untag') {
                  wordElement.classList.add('text-red-600');
                  setCountWord((prevCount) => prevCount + 1);
                  setCountRedWord((prevCount) => prevCount + 1);
              } else if (mot[1].FORM === 'unlex') {
                  wordElement.classList.add('text-orange-500');
                  setCountWord((prevCount) => prevCount + 1);
                  setCountOrangeWord((prevCount) => prevCount + 1);
              } else {
                  setCountWord((prevCount) => prevCount + 1);
              }
              wordElement.addEventListener('mouseenter', function (ev) {
                ev.preventDefault();
                this.style.position = 'relative';
                this.innerHTML = this.innerHTML + "<div class='Tooltips' contentEditable='false'><p>" + mot[1].SYNT + '<br />' + mot[1].LEMMA + '</p></div>';
              });

              wordElement.addEventListener('mouseleave', function (ev) {
                ev.preventDefault();
                this.innerHTML = this.innerHTML.replace(/<div[^]*?<\/div>/, '');
              });

              // Add double-click event listener to each word element
              wordElement.addEventListener('dblclick', function () {
                handleWordDoubleClick(this.innerText, mot[1]['INDEX']);
              });
            }
            outputText.push(wordElement);
          }
        });
        const resultContainer = document.getElementById('result');
        resultContainer.innerHTML = '';

        outputText.forEach((wordElement) => {
          resultContainer.appendChild(wordElement);
          resultContainer.appendChild(document.createTextNode(' ')); // Add a space between words
        });

        setJsonData(data)
        setUpdatedJsonData(data)
      }
      if (location.state.error){
        // Recharge l'analyse d'erreur qui a déjà été effectuée
        const resultError = location.state.error

        const dataError = JSON.parse(resultError)
        let outputTextError = [];

        Object.entries(dataError).forEach((mot) => {
          mot[1]['INDEX'] = mot[0];

          if (typeof mot[1].WORD === 'string' && mot[1].INDEX !== 'top') {
            let wordElement = document.createElement('span');
            wordElement.innerText = mot[1].ORTHO;

            if (mot[1].SYNT !== 'PON') {
              if (mot[1].FORM === 'untag') {
                  wordElement.classList.add('text-red-600');
              } else if (mot[1].FORM === 'unlex') {
                  wordElement.classList.add('text-orange-500');
              } else if (mot[1].FORM === 'untaginlex' || mot[1].FORM === 'unlexinlex' || mot[1].FORM === 'taglexinlex') {
                wordElement.classList.add('text-green-700');
              }

              wordElement.addEventListener('mouseenter', function (ev) {
                ev.preventDefault();
                this.style.position = 'relative';
                this.innerHTML = this.innerHTML + "<div class='Tooltips' contentEditable='false'><p>" + mot[1].SYNT + '<br />' + mot[1].LEMMA + '</p></div>';
              });

              wordElement.addEventListener('mouseleave', function (ev) {
                ev.preventDefault();
                this.innerHTML = this.innerHTML.replace(/<div[^]*?<\/div>/, '');
              });
            }
            outputTextError.push(wordElement);
          }
        });
        const resultContainerError = document.getElementById('resultError');
        resultContainerError.innerHTML = '';

        outputTextError.forEach((wordElement) => {
          resultContainerError.appendChild(wordElement);
          resultContainerError.appendChild(document.createTextNode(' ')); // Add a space between words
        });

        setCorrectedJsonData(dataError)
      }
    }
  }, []);

  const openModalStatText = () => {
    setModalStatText(true);
  };

  const openModalStatError = () => {
    setModalStatError(true);
  }

  const openModalStatComp = () => {
    setModalStatComp(true);
  }

  const handleSaveWord = (editedProperties) => {
    const index = editedProperties.index;
    const jsonToUpdate = updatedJsonData;
    if (index in jsonToUpdate) {
      jsonToUpdate[index] = { 
        ...jsonToUpdate[index],
        TARGET_WORD: editedProperties.target,
        TARGET_POS: editedProperties.synt,
        TARGET_LEMMA: editedProperties.lemma};
      setUpdatedJsonData(jsonToUpdate);
      setModalVisible(false);

      let outputText = [];

        Object.entries(jsonToUpdate).forEach((mot) => {
        // mot[1]['INDEX'] = mot[0];

        if (typeof mot[1].WORD === 'string' && mot[1].INDEX !== 'top') {
          let wordElement = document.createElement('span');
          wordElement.innerText = mot[1].WORD;

          if (mot[1].SYNT !== 'PON') {
          if (mot[1].FORM === 'untag') {
              wordElement.classList.add('text-red-600');
              // setCountWord((prevCount) => prevCount + 1);
              // setCountRedWord((prevCount) => prevCount + 1);
          } else if (mot[1].FORM === 'unlex') {
              wordElement.classList.add('text-orange-500');
              // setCountWord((prevCount) => prevCount + 1);
              // setCountOrangeWord((prevCount) => prevCount + 1);
          } else {
              // setCountWord((prevCount) => prevCount + 1);
          }

          if (mot[1].TARGET_WORD){
            wordElement.style.fontWeight = "bold";
            wordElement.addEventListener('mouseenter', function (ev) {
              ev.preventDefault();
              this.style.position = 'relative';
              this.innerHTML = this.innerHTML + "<div class='Tooltips' contentEditable='false'><p>" + mot[1].TARGET_WORD + '<br />' + mot[1].TARGET_POS + '<br />' + mot[1].TARGET_LEMMA + '</p></div>';
            });
          } else {
            wordElement.addEventListener('mouseenter', function (ev) {
              ev.preventDefault();
              this.style.position = 'relative';
              this.innerHTML = this.innerHTML + "<div class='Tooltips' contentEditable='false'><p>" + mot[1].SYNT + '<br />' + mot[1].LEMMA + '</p></div>';
            });
          }

          wordElement.addEventListener('mouseleave', function (ev) {
            ev.preventDefault();
            this.innerHTML = this.innerHTML.replace(/<div[^]*?<\/div>/, '');
          });

          // Add double-click event listener to each word element
          wordElement.addEventListener('dblclick', function () {
            handleWordDoubleClick(this.innerText, mot[1]['INDEX']);
          });
          }
          outputText.push(wordElement);
        }
        });
        const resultContainer = document.getElementById('result');
        resultContainer.innerHTML = '';

        outputText.forEach((wordElement) => {

          resultContainer.appendChild(wordElement);
          resultContainer.appendChild(document.createTextNode(' ')); // Add a space between words
        });

    } else {
      console.error(`Word with index ${index} not found in jsonData.`);
    }
  };

  const handleWordDoubleClick = (mot, index) => {
    setModalVisible(true)
    const myvar = mot.split(/\n/)
    myvar.push(index)
    setEditingWord(myvar)
  };

  const analyseText = async () => {
    try {
        setCountWord(0);
        setCountOrangeWord(0);
        setCountRedWord(0);
        document.getElementById('result').innerHTML = '';
        document.getElementById('resultError').innerHTML = '';
        setJsonData(null);
        setUpdatedJsonData(null);
        setCorrectedJsonData(null);
        setAlertVisible(true);

        const userId = user.id
        const mytext = document.getElementById('mytext');
        const input = mytext.value

        if (!input) {
          setAlertVisible(false);
          return;
        }

        // const response = await fetch(`http://themis.msh-lse.fr:3080/usage-analysis?text=${input}`);
        // const response = await fetch(`http://localhost:3080/usage-analysis?text=${input}`);
        const response = await fetch(`${config.BASE_URL}/usage-analysis?text=${input}`);
        const output = await response.json();
        const result = output[0]

        // const save = await fetch(`http://themis.msh-lse.fr:3080/save`, {
        // const save = await fetch(`http://localhost:3080/save`, {
        const save = await fetch(`${config.BASE_URL}/save`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ userId, input, result }),
        });

        const analysisId = await save.json()
        console.log("ID : ", analysisId.id)
        setAnalysisId(analysisId.id)

        const data = JSON.parse(result)
        let outputText = [];

        Object.entries(data).forEach((mot) => {
        mot[1]['INDEX'] = mot[0];

        
        if (typeof mot[1].WORD === 'string' && mot[1].INDEX !== 'top') {
          let wordElement = document.createElement('span');
          wordElement.innerText = mot[1].WORD;

          if (mot[1].SYNT !== 'PON') {
          if (mot[1].FORM === 'untag') {
              wordElement.classList.add('text-red-600');
              setCountWord((prevCount) => prevCount + 1);
              setCountRedWord((prevCount) => prevCount + 1);
          } else if (mot[1].FORM === 'unlex') {
              wordElement.classList.add('text-orange-500');
              setCountWord((prevCount) => prevCount + 1);
              setCountOrangeWord((prevCount) => prevCount + 1);
          } else {
              setCountWord((prevCount) => prevCount + 1);
          }
          wordElement.addEventListener('mouseenter', function (ev) {
            ev.preventDefault();
            this.style.position = 'relative';
            this.innerHTML = this.innerHTML + "<div class='Tooltips' contentEditable='false'><p>" + mot[1].SYNT + '<br />' + mot[1].LEMMA + '</p></div>';
          });

          wordElement.addEventListener('mouseleave', function (ev) {
            ev.preventDefault();
            this.innerHTML = this.innerHTML.replace(/<div[^]*?<\/div>/, '');
          });

          // Add double-click event listener to each word element
          wordElement.addEventListener('dblclick', function () {
            handleWordDoubleClick(this.innerText, mot[1]['INDEX']);
          });
          }
          outputText.push(wordElement);
        }
        });
        const resultContainer = document.getElementById('result');
        resultContainer.innerHTML = '';

        outputText.forEach((wordElement) => {

          resultContainer.appendChild(wordElement);
          resultContainer.appendChild(document.createTextNode(' ')); // Add a space between words
        });

        setJsonData(data)
        setUpdatedJsonData(data)
    } catch (error) {
        console.error('Error during analysis: ', error);
    } finally {
      // Hide alert when analysis finishes (either success or failure)
      setAlertVisible(false);
    }
  };

  const relancerAnalyse = () => {
    setCountWord(0);
    setCountOrangeWord(0);
    setCountRedWord(0);
    document.getElementById('result').innerHTML = '';
    document.getElementById('mytext').value = '';
    document.getElementById('resultError').innerHTML = '';
    setJsonData(null)
    setUpdatedJsonData(null);
    setCorrectedJsonData(null);
  };

  // Download json in csv format
  // const telechargerResultat = (json) => {
  //   const fileName = 'texte_analyse'
  //   const exportType = exportFromJSON.types.csv
  //   const json_csv = []
  //   Object.entries(json).forEach(mot => {
  //       if (typeof mot[1].ORTHO === 'string' && mot[0] !== "top") {
  //           json_csv.push(mot[1])
  //       }
  //   })
  //   exportFromJSON({ data: json_csv, fileName: fileName, exportType: exportType })
  // };

  // Download json in xlsx format
  const telechargerResultat = (json) => {
    const fileName = 'texte_analyse'
    const exportType = exportFromJSON.types.xls
    const json_xls = []
    Object.entries(json).forEach(mot => {
        if (typeof mot[1].ORTHO === 'string' && mot[0] !== "top") {
            json_xls.push(mot[1])
        }
    })
    exportFromJSON({ data: json_xls, fileName: fileName, exportType: exportType })
  };

  const analyseErrors = async () => {
    try {
        document.getElementById('resultError').innerHTML = '';
        setCorrectedJsonData(null)
        setAlertVisible(true);

        // const userId = user.id
        const input = updatedJsonData
        if (!input) {
          setAlertVisible(false);
          return;
        }

        const hasTargetWord = Object.keys(jsonData).some(key => "TARGET_WORD" in jsonData[key]);
        if (!hasTargetWord) {
          console.error("No entry has the key 'TARGET_WORD'");
          setAlertVisible(false);
          return;
        }

        // const response = await fetch(`http://themis.msh-lse.fr:3080/error-analysis`, {
        // const response = await fetch(`http://localhost:3080/error-analysis`, {
        const response = await fetch(`${config.BASE_URL}/error-analysis`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ input }),
        });
        const output = await response.json();
        const result = output[0]

        const save = await fetch(`${config.BASE_URL}/save-error-analysis`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ analysisId, result }),
        });
        await save.json();

        const data = JSON.parse(result)
        let outputText = [];

        Object.entries(data).forEach((mot) => {
          mot[1]['INDEX'] = mot[0];

          if (typeof mot[1].WORD === 'string' && mot[1].INDEX !== 'top') {
            let wordElement = document.createElement('span');
            wordElement.innerText = mot[1].ORTHO;

            if (mot[1].SYNT !== 'PON') {
            if (mot[1].FORM === 'untag') {
                wordElement.classList.add('text-red-600');
            } else if (mot[1].FORM === 'unlex') {
                wordElement.classList.add('text-orange-500');
            } else if (mot[1].FORM === 'untaginlex' || mot[1].FORM === 'unlexinlex' || mot[1].FORM === 'taglexinlex') {
              wordElement.classList.add('text-green-700');
            }
            wordElement.addEventListener('mouseenter', function (ev) {
              ev.preventDefault();
              this.style.position = 'relative';
              this.innerHTML = this.innerHTML + "<div class='Tooltips' contentEditable='false'><p>" + mot[1].SYNT + '<br />' + mot[1].LEMMA + '</p></div>';
            });

            wordElement.addEventListener('mouseleave', function (ev) {
              ev.preventDefault();
              this.innerHTML = this.innerHTML.replace(/<div[^]*?<\/div>/, '');
            });
            }
            outputText.push(wordElement);
          }
          });
          const resultContainer = document.getElementById('resultError');
          resultContainer.innerHTML = '';

          outputText.forEach((wordElement) => {
            resultContainer.appendChild(wordElement);
            resultContainer.appendChild(document.createTextNode(' ')); // Add a space between words
          });

          setCorrectedJsonData(data)
          } catch (error) {
              console.error('Error during error analysis: ', error);
          } finally {
            // Hide alert when analysis finishes (either success or failure)
            setAlertVisible(false);
          }
  };

  return (
    <div className="mx-8">
      <h1 className="py-4 text-xl font-bold leading-tight tracking-tight text-gray-900">Outils d'analyse</h1>
      {isAlertVisible && (
        <Alert bgColor="bg-yellow-50" message="Analyse en cours..." />
      )}
      {location.state ? (
       <TextareaInput defaultText={location.state.text} />
      ) : (
        <TextareaInput />
      )}
      <div className="py-4">
        <span className="isolate inline-flex rounded-md shadow-sm">
          <button
            type="button"
            className="relative -ml-px inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
            onClick={analyseText}
          >
            Analyser le texte
          </button>
          <button
            type="button"
            className="relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
            onClick={relancerAnalyse}
          >
            Relancer une analyse
          </button>
        </span>
      </div>
      
      <div className="mt-1 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-4">
        <div className="sm:col-span-full">
          <div>
            {/* <h1 className="mt-4 text-md font-medium text-gray-700">Analyse des mots produits et corrects</h1> */}
            <InfoPoint title="2) Analyse des mots produits et corrects" information="Les mots en rouge sont ceux non reconnus par TreeTagger. Les mots en orange sont ceux non reconnus par Lexique." />
          </div>
        </div>
        <div className="sm:col-span-3">
          <div>
            <div className="py-4 p-2.5 bg-white block w-full rounded-md border border-gray-300 shadow-sm focus:outline-none" id="result" contentEditable={true} />
          </div>
        </div>
        <div className="sm:col-span-1">
          <div>
            <WordTag visible={modalVisible} onClose={() => setModalVisible(false)} onSave={handleSaveWord} word={editingWord} />
          </div>
        </div>
        <div className="sm:col-span-full">
          <div className="mt-2">
            <span> {countWord} mots, {countRedWord + countOrangeWord} non reconnu{countRedWord + countOrangeWord > 1 ? 's' : ''}</span>
            {/* <span> {countWord} mots, <span className="text-red-700">{countRedWord} inconnu{countRedWord > 1 ? 's' : ''}</span>, <span className="text-orange-700">{countOrangeWord} mal connu{countOrangeWord > 1 ? 's' : ''}</span></span> */}
          </div>
        </div>
      </div>

      <div>
      {jsonData && (
        <span className="pt-4 isolate inline-flex rounded-md shadow-sm">
          {/* <Statistics data={jsonData} condition={0}/> */}
          <button
            className="relative -ml-px inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
            type="submit"
            onClick={openModalStatText}
          >
            Voir les statistiques
          </button>
          <Statistics open={modalStatText} onClose={() => setModalStatText(false)} data={jsonData} condition={0} />
          <button
            type="button"
            className="relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
            onClick={() => telechargerResultat(jsonData)}
          >
            <HiDownload />
          </button>
        </span>
      )}
      </div>

      <div className="py-4">
      {jsonData && (
        <span className="isolate inline-flex rounded-md shadow-sm">
          <button
            type="button"
            className="relative -ml-px inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
            onClick={analyseErrors}
          >
            Analyser les erreurs
          </button>
        </span>
      )}
      </div>

      <div className="mt-1 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-4">
        <div className="sm:col-span-full">
          <div>
            {/* <h1 className="mt-4 text-md font-medium text-gray-700">Analyse des mots cibles des mots erronés</h1> */}
            <InfoPoint title="3) Analyse des mots cibles des mots erronés" information="Les mots en vert sont les mots corrigés et reconnus par Lexique." />
          </div>
        </div>
        <div className="sm:col-span-3">
          <div>
            <div className="py-4 p-2.5 bg-white block w-full rounded-md border border-gray-300 shadow-sm focus:outline-none" id="resultError" contentEditable={true} />
          </div>
        </div>
      </div>

      <div>
        {correctedJsonData && (
        <span className="pt-4 isolate inline-flex rounded-md shadow-sm">
          {/* <Statistics data={correctedJsonData} condition={1}/> */}
          <button
            className="relative -ml-px inline-flex items-center rounded-l-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
            type="submit"
            onClick={openModalStatError}
          >
            Voir les statistiques
          </button>
          <Statistics open={modalStatError} onClose={() => setModalStatError(false)} data={correctedJsonData} condition={1} />
          <button
            type="button"
            className="relative -ml-px inline-flex items-center rounded-r-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
            onClick={() => telechargerResultat(correctedJsonData)}
          >
          <HiDownload />
          </button>
        </span>
        )}
      </div>
      <div className='py-4'>
        {jsonData && correctedJsonData && (
        <span className="isolate inline-flex rounded-md shadow-sm">
          <button
            type="button"
            className="relative -ml-px inline-flex items-center rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100"
            onClick={openModalStatComp}
          >
            Statistiques comparatives
          </button>
          <Statistics open={modalStatComp} onClose={() => setModalStatComp(false)} data={correctedJsonData} condition={2} />
        </span>
        )}
      </div>
    </div>
  );
}

export default Analyse;
